import { forwardRef, useEffect, useRef, useState } from "react";

import "./ClassRailroadVisible.css";
import { useScreenSize } from "../../../../context/useScreenSize";
import ClassRailroadMobile from "./ClassRailroadMobile";
import ClassRailroadVisible from "./ClassRailroadVisible";
import ErrorBoundary from "../../../../utilities/ErrorBoundary";

export type ClassIRailroadLegendHandle = {
  toggleClassIRailroadsVisible: () => void;
}

interface iProps {
  view: __esri.MapView;
}

type Ref = HTMLDivElement;

const ClassRailroadWrapper = forwardRef<Ref, iProps>(({ view }, ref) => {
  const { useMobileSummaryScreen } = useScreenSize();

  const [classIRailroadsVisible, setClassIRailroadsVisible] = useState(false);
  const [classIRailroadLayer, setClassIRailroadLayer] = useState<__esri.GroupLayer>();

  const mobileLegendRef = useRef<ClassIRailroadLegendHandle>(null);
  const legendRef = useRef<ClassIRailroadLegendHandle>(null);


  useEffect(() => {
    view.when(() => {
      setClassIRailroadLayer(
        view.map.layers
          .find(layer => layer.title === 'Class I Railroads') as __esri.GroupLayer
      );
    });
  }, [view]);

  const toggleClassIRailroadsVisible = () => {
    if (useMobileSummaryScreen) {
      mobileLegendRef.current?.toggleClassIRailroadsVisible();
    } else {
      legendRef.current?.toggleClassIRailroadsVisible();
    }
  }

  return (
    <>
      <div ref={ref} className="esri-component">
        <div className="class-visible-container">
          <input type="checkbox" id="show-class-i-checkbox"
            checked={classIRailroadsVisible}
            onChange={toggleClassIRailroadsVisible} />
          <label htmlFor="show-class-i-checkbox"><strong>Show Class I Railroads</strong></label>
        </div>
      </div>
      {useMobileSummaryScreen ?
        <ErrorBoundary>
          <ClassRailroadMobile
            ref={mobileLegendRef}
            view={view}
            classIRailroadsVisible={classIRailroadsVisible}
            classIRailroadLayer={classIRailroadLayer}
            setClassIRailroadsVisible={setClassIRailroadsVisible}
          />
        </ErrorBoundary>
        :
        <ErrorBoundary>
          <ClassRailroadVisible
            ref={legendRef}
            view={view}
            classIRailroadLayer={classIRailroadLayer}
            setClassIRailroadsVisible={setClassIRailroadsVisible}
          />
        </ErrorBoundary>
      }
    </>
  );
});

export default ClassRailroadWrapper;